'use client';

interface SaveConfirmationModalProps {
  isOpen: boolean;
  isSaving: boolean;
  onSaveAndContinue: () => void;
  onDiscardAndContinue: () => void;
}

export default function SaveConfirmationModal({ isOpen, isSaving, onSaveAndContinue, onDiscardAndContinue }: SaveConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onDiscardAndContinue}></div>

      {/* Modal content */}
      <div className="relative bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 max-w-xs sm:max-w-md w-full shadow-2xl border border-gray-200 z-[10000]">
        <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900">Unsaved Changes</h3>
        </div>

        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">You have unsaved changes to this question. What would you like to do?</p>

        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 justify-end">
          <button onClick={onDiscardAndContinue} className="px-3 sm:px-4 py-2 text-sm sm:text-base text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium cursor-pointer">
            Discard Changes
          </button>
          <button onClick={onSaveAndContinue} disabled={isSaving} className="px-3 sm:px-4 py-2 text-sm sm:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium cursor-pointer">
            {isSaving ? 'Saving...' : 'Save & Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
